angular
    .module("genericChecklistDownload.components", [])
    .component("genericChecklistDownload", {
        templateUrl: "ng/components/genericChecklistDownload/genericChecklistDownload.view.html",
        bindings: {
            listOfDocument: '=',
            model: '=',
            linkDownload: '@',
            restFinish: '<',
            message: '<',
            accordoConvenzionamento: '<',
            validateComponent: '&'
        },
        controllerAs: "checkListDownCtrl",
        controller: GenericChecklistDownloadController
    })

function GenericChecklistDownloadController(
    $download
) {
    var self = this;

    self.$onInit = function () {
        console.log(self.message)
        checkAllFileDownloaded()
    }


    self.$onChanges = function (changed) {

        if (changed.restFinish && typeof changed.restFinish.currentValue != "undefined") {
            self.waitFromRest = changed.restFinish.currentValue;
            if (!changed.restFinish.currentValue) {
                checkInformative();
                checkCorrectPositionName();
            }
        }

    }

    var checkInformative = function () {
        self.informativeIsPresent = self.listOfDocument && self.listOfDocument
            .some(function (element) {
                return element.informative == true
            })

        self.informativeIsNotPresent = self.listOfDocument && self.listOfDocument
            .some(function (element) {
                return element.informative == false
            })
    }

    self.generdownloadDoc = function (file) {
        var url = "/uni/downloadDocPv/service-infos/";
        var input = {
            downloadKey: file.downloadKey
        }
        $download.getGenericDownload(url, input)
            .then(function (response) {
                console.log(response)
            })
    };

    self.fileIsDownloaded = function (index, file) {
        self.generdownloadDoc(file)
        self.listOfDocument[index].downloaded = true;
        self.singleFileIsDownloaded(file, index);
        checkAllFileDownloaded();
    }

    var checkCorrectPositionName = function () {
        self.listOfDocument.forEach(function (element) {
            element.docNameLabel = !!element.docNameLabel ? element.docNameLabel : element.linfaNomeDocumento
        })
    }

    self.singleFileIsDownloaded = function (singleFile, index) {
        self.listOfDocument.forEach(function (document) {
            document.uploadedFiles.forEach(function (file) {
                if (file == singleFile) {
                    if (file[index] && !file[index].downloaded) {
                        file[index].downloaded = true;
                    }
                }
            });
        })
    }

    var checkAllFileDownloaded = function () {

        var testing = self.listOfDocument && self.listOfDocument
            .filter(x => {
                return x.mandatory
            })
            .every(x => {
                return x.downloaded == true;
            })

        self.validateComponent && self.validateComponent({
            validate: testing
        })
    }

    self.downloadZip = function () {
        // chiamerò un rest per il download dello zip 
        self.showLoaderDownloadZip = true;

        var url = '/simulator/downloadZipCheckListContrattoConvenzionamento/'
        $download.getGenericDownload(url)
            .then(function (response) {
                self.listOfDocument.forEach(x => {
                    x.downloaded = true
                })
                checkAllFileDownloaded();

                self.showLoaderDownloadZip = false;
            })
            .catch(function (error) {
                console.error(error);
                self.showLoaderDownloadZip = false;
            })


    }
}